import { cn } from '@/shared/lib/shadcn/utils';

export const PageCard = ({
  children,
  className,
  innerClassName,
}: {
  children: React.ReactNode;
  className?: string;
  innerClassName?: string;
}) => {
  return (
    <div className={cn('page-wrapper p-7', className)}>
      <div
        className={cn(
          'page-wrapper__top-inner rounded-24 bg-white p-8',
          innerClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
};
